import { twMerge } from 'tailwind-merge';
import { translations } from '../../../../utils/language';

export const CHECKOUT_COLORS = [
	{ value: 'gray', hex: '#4B5563', labelKey: 'thema-cinza', label: 'Cinza' },
	{ value: 'slate', hex: '#475569', labelKey: 'thema-ardosia', label: 'Ardósia' },
	{ value: 'stone', hex: '#78716C', labelKey: 'thema-pedra', label: 'Pedra' },
	{ value: 'red', hex: '#DC2626', labelKey: 'thema-vermelho', label: 'Vermelho' },
	{ value: 'rose', hex: '#E11D48', labelKey: 'thema-rosa-escuro', label: 'Rosa escuro' },
	{ value: 'orange', hex: '#EA580C', labelKey: 'thema-laranja', label: 'Laranja' },
	{ value: 'amber', hex: '#D97706', labelKey: 'thema-ambar', label: 'Âmbar' },
	{ value: 'yellow', hex: '#CA8A04', labelKey: 'thema-amarelo', label: 'Amarelo' },
	{ value: 'lime', hex: '#65A30D', labelKey: 'thema-lima', label: 'Lima' },
	{ value: 'green', hex: '#16A34A', labelKey: 'thema-verde', label: 'Verde' },
	{ value: 'emerald', hex: '#059669', labelKey: 'thema-esmeralda', label: 'Esmeralda' },
	{ value: 'teal', hex: '#0D9488', labelKey: 'thema-verde-azulado', label: 'Verde-azulado' },
	{ value: 'cyan', hex: '#0891B2', labelKey: 'thema-ciano', label: 'Ciano' },
	{ value: 'sky', hex: '#0284C7', labelKey: 'thema-ceu', label: 'Céu' },
	{ value: 'blue', hex: '#2563EB', labelKey: 'thema-azul', label: 'Azul' },
	{ value: 'indigo', hex: '#4F46E5', labelKey: 'thema-indigo', label: 'Índigo' },
	{ value: 'violet', hex: '#7C3AED', labelKey: 'thema-violeta', label: 'Violeta' },
	{ value: 'purple', hex: '#9333EA', labelKey: 'thema-roxo', label: 'Roxo' },
	{ value: 'fuchsia', hex: '#C026D3', labelKey: 'thema-fucsia', label: 'Fúcsia' },
	{ value: 'pink', hex: '#DB2777', labelKey: 'thema-rosa', label: 'Rosa' },
	{ value: 'black', hex: '#171717', labelKey: 'thema-preto', label: 'Preto' },
];

const FALLBACK = CHECKOUT_COLORS.find((c) => c.value === 'gray') || CHECKOUT_COLORS[0];

const BUTTON_BASE =
	'inline-flex items-center gap-x-1.5 rounded-md px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2';

const BADGE_BASE = 'rounded px-2 py-1 text-xs font-semibold shadow-sm';

export const getCheckoutColor = (value) =>
	CHECKOUT_COLORS.find((color) => color.value === value) || FALLBACK;

export const getCheckoutColorHex = (value) => getCheckoutColor(value).hex;

export const getCheckoutButtonClass = () => BUTTON_BASE;

export const getCheckoutButtonStyle = (value) => ({
	backgroundColor: getCheckoutColorHex(value),
});

export const getCheckoutBadgeClass = () => BADGE_BASE;

export const getCheckoutBadgeStyle = (value) => {
	const hex = getCheckoutColorHex(value);
	return {
		backgroundColor: `${hex}1A`,
		color: hex,
	};
};

const ColorSwatchPicker = ({
	value = 'gray',
	onChange,
	colors = CHECKOUT_COLORS,
	language = 'pt',
	className,
	ariaLabel,
}) => {
	return (
		<div
			role="radiogroup"
			aria-label={ariaLabel}
			className={twMerge('grid grid-cols-7 gap-2 w-fit', className)}
		>
			{colors.map((color) => {
				const selected = value === color.value;
				const label =
					(color.labelKey && translations[color.labelKey]?.[language]) || color.label || color.value;

				return (
					<button
						key={color.value}
						type="button"
						role="radio"
						aria-checked={selected}
						aria-label={label}
						title={label}
						onClick={() => onChange?.(color.value)}
						className={twMerge(
							'size-7 rounded-full border border-black/10 transition-transform active:scale-95',
							'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-900/20 focus-visible:ring-offset-2',
							selected && 'ring-2 ring-gray-900 ring-offset-2'
						)}
						style={{ backgroundColor: color.hex }}
					/>
				);
			})}
		</div>
	);
};

export default ColorSwatchPicker;
